import { useMemo } from 'react';
import { useFieldArray } from 'react-hook-form';

import EnumSelect from 'components/field/EnumSelect';
import StringInput from 'components/field/StringInput';
import Table from 'components/table/Table';

import useMediaQuery from 'hooks/useMediaQuery';

import { ENUMS } from 'services/consts';

import { Breakpoints } from 'utils/const.styles';

const ReasonLanguageList = ({ isLoading, control, watch, setValue }) => {
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const {
		fields: reasonLangFields,
		append: appendReasonLang,
		remove: removeReasonLang
	} = useFieldArray({ control, name: 'reasonLangList' });

	const removeItem = async ({ index }) => {
		removeReasonLang(index);
	};
	const columns = useMemo(
		() => [
			{
				id: 'reasonLangList.reasonLang',
				header: 'language',
				accessor: 'reasonLangList.reasonLang',
				size: isMobile ? 40 : 100,
				renderCell: ({ row: { index } }) => (
					<EnumSelect
						searchable={false}
						valueRemovable={false}
						required
						placeholder="selectOne"
						name={`reasonLangList[${index}].reasonLang`}
						enumName={ENUMS.LANGUAGE_CODES}
						value={watch(`reasonLangList[${index}].reasonLang`)}
						setValue={(value) => {
							setValue(`reasonLangList[${index}].reasonLang`, value, {
								shouldValidate: true,
								shouldDirty: true
							});
						}}
					/>
				),
				showOnMobile: true
			},
			{
				id: 'reasonLangList.reason',
				header: 'reason',
				accessor: 'reasonLangList.reason',
				size: isMobile ? 40 : 100,
				renderCell: ({ row: { index } }) => <StringInput required name={`reasonLangList[${index}].reason`} />,
				showOnMobile: true
			},
			{
				id: 'deleteRow',
				size: 20,
				maxSize: 20,
				showOnMobile: true
			}
		],
		[isMobile]
	);

	return (
		<Table
			loading={isLoading}
			data={reasonLangFields}
			columns={columns}
			onRowDelete={(row) => {
				removeItem(row);
			}}
			onRowAdd={() => {
				appendReasonLang({});
			}}
			showAddNewRowButton={reasonLangFields.length < 3}
			initEditMode={(row) => row.id === null}
		/>
	);
};

export default ReasonLanguageList;
